<template>
  <div id="settingsWrapper">
    <h1 class="title">Instellingen</h1>

    <div class="tabs">
      <ul>
        <router-link tag="li" :to="{ name: 'settings' }" :class="{ 'is-active': $route.name === 'settings' }"><a>Cache</a></router-link>
        <router-link tag="li" :to="{ name: 'processes' }" :class="{ 'is-active': $route.name === 'processes' }"><a>Processen</a></router-link>
      </ul>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>
